export default function assignOrganization(basicEntity: any, providerBlob: any) {
    if (basicEntity && providerBlob) {
        return {
            basicEntity,
            ...{
                name: providerBlob.name,
                telephone: providerBlob.telephone,
            },
        };
    } else {
        return null;
    }
}
